module.exports = require('./dist/date/date.js');
